import * as React from 'react'
import styled from 'styled-components'

import { t, tc } from '@owl-nest/localize'
import * as plume from '@ulule/owl-kit-components/next'

import { DashedArrowXS } from './Vectors'

export function AccountCreationBlock(): React.ReactElement {
  return (
    <AccountCreationBlockWrapper>
      <plume.styles.heading.XS asDesktop="L">
        {tc(
          '[link: Create your Ulule account] to receive a weekly selection of the best projects and start taking action!',
          {
            link: <plume.Link href="https://fr.ulule.com/signup/" tinted />,
          },
        )}

        <DashedArrowXS />
      </plume.styles.heading.XS>
      <plume.ButtonAsLink href="https://fr.ulule.com/signup/" kind="primary">
        {t('Create your Ulule account')}
      </plume.ButtonAsLink>
    </AccountCreationBlockWrapper>
  )
}

const AccountCreationBlockWrapper = styled.div`
  margin: 70px auto;
  max-width: 90vw;
  min-height: 308px;
  display: flex;
  flex-direction: column;
  padding: 48px 24px;
  align-items: center;
  justify-content: space-between;
  background-image: url('${process.env.ASSET_PREFIX}/assets/img/discover/account_creation_block_bg.svg');
  background-repeat: no-repeat;
  background-size: 100% 308px;
  background-position: center;

  ${plume.styles.heading.XS} {
    position: relative;
  }

  ${DashedArrowXS} {
    display: none;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    padding: 52px 34px;
    margin: 120px auto;
    max-width: 700px;
    text-align: center;

    ${DashedArrowXS} {
      display: block;
      position: absolute;
      right: 18%;
      bottom: -50%;
      transform: rotateZ(40deg);
    }
  }

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    height: 378px;
    max-width: 864px;
    margin: 140px auto;
    padding: 80px 140px;
    background-size: contain;

    ${DashedArrowXS} {
      right: 15%;
      bottom: -60%;
      transform: rotateZ(40deg) scale(1.2);
    }
  }
`
